import React from 'react';
import Input from '../../../components/ui/Input';

const PatientInformationSection = ({ data, errors, onChange }) => {
  const handleChange = (field) => (e) => {
    onChange('patientInfo', field, e?.target?.value);
  };

  const currentYear = new Date()?.getFullYear();
  const yearOptions = Array.from({ length: 100 }, (_, i) => currentYear - i);

  return (
    <div className="glass-card rounded-2xl p-6 hover-glow hover-lift">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-white mb-1">
          Informations Patient
        </h2>
        <p className="text-sm text-gray-400">
          Informations anonymisées
        </p>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Nom du patient"
            type="text"
            placeholder="Dupont"
            value={data?.lastName}
            onChange={handleChange('lastName')}
            error={errors?.lastName}
            required
          />

          <Input
            label="Prénom du patient"
            type="text"
            placeholder="Marie"
            value={data?.firstName}
            onChange={handleChange('firstName')}
            error={errors?.firstName}
            required
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Native select for year - mobile friendly */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-200">
              Année de naissance <span className="text-red-400">*</span>
            </label>
            <select
              value={data?.yearOfBirth}
              onChange={handleChange('yearOfBirth')}
              className="w-full h-12 px-4 py-3 bg-[rgba(245,245,247,0.95)] border border-white/20 rounded-2xl text-[#1A1A1A] font-medium text-base focus:outline-none focus:border-primary/60 focus:ring-2 focus:ring-primary/30 focus:shadow-[0_0_20px_rgba(74,144,226,0.2)] transition-all"
              style={{ fontSize: '16px' }}
            >
              <option value="" className="bg-white">Sélectionner l'année</option>
              {yearOptions?.map(year => (
                <option key={year} value={year} className="bg-white">
                  {year}
                </option>
              ))}
            </select>
            {errors?.yearOfBirth && (
              <p className="text-sm text-red-400">{errors?.yearOfBirth}</p>
            )}
          </div>

          {/* Radio buttons for sex */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-200">
              Sexe (optionnel)
            </label>
            <div className="flex flex-wrap gap-3 pt-2">
              <label className="flex items-center gap-2 cursor-pointer px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-primary/40 transition-all">
                <input
                  type="radio"
                  name="sex"
                  value="male"
                  checked={data?.sex === 'male'}
                  onChange={handleChange('sex')}
                  className="w-4 h-4 text-primary bg-white/20 border-white/30 focus:ring-2 focus:ring-primary/50"
                />
                <span className="text-sm text-gray-300">Homme</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-primary/40 transition-all">
                <input
                  type="radio"
                  name="sex"
                  value="female"
                  checked={data?.sex === 'female'}
                  onChange={handleChange('sex')}
                  className="w-4 h-4 text-primary bg-white/20 border-white/30 focus:ring-2 focus:ring-primary/50"
                />
                <span className="text-sm text-gray-300">Femme</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer px-4 py-2.5 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-primary/40 transition-all">
                <input
                  type="radio"
                  name="sex"
                  value="other"
                  checked={data?.sex === 'other'}
                  onChange={handleChange('sex')}
                  className="w-4 h-4 text-primary bg-white/20 border-white/30 focus:ring-2 focus:ring-primary/50"
                />
                <span className="text-sm text-gray-300">Autre</span>
              </label>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Téléphone du patient"
            type="tel"
            placeholder="06 12 34 56 78"
            value={data?.phone}
            onChange={handleChange('phone')}
            error={errors?.phone}
          />

          <Input
            label="Email du patient"
            type="email"
            placeholder="patient@example.com"
            value={data?.email}
            onChange={handleChange('email')}
            error={errors?.email}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientInformationSection;